module.exports = __webpack_public_path__ + "img/bg02.ddec7542.svg";